export default __webpack_public_path__ + "static/media/24.14b2b674.svg";